/* eslint-disable max-len */
export default {
  'polygon drawing instructions': 'Clique no mapa para adicionar os vértices da área.',
  'finish polygon drawing': 'Concluir desenho',
  'undo polygon point': 'Desfazer ponto',
  'datagrid body empty data source message': 'Nenhum registro encontrado',
  'datagrid body add tooltip': 'Adicionar',
  'datagrid body delete tooltip': 'Remover',
  'datagrid body permanently delete tooltip': 'Remover permanentemente',
  'datagrid body delete everything tooltip': 'Excluir tudo',
  'datagrid body inactivate tooltip': 'Inativar',
  'datagrid body activate tooltip': 'Ativar',
  'datagrid body access tooltip': 'Acessar',
  'datagrid body edit tooltip': 'Editar',
  'datagrid body edit row delete text':
    'Você tem certeza que deseja deletar esse registro?',
  'datagrid body edit row cancel tooltip': 'Cancelar',
  'datagrid body edit row save tooltip': 'Salvar',
  'datagrid body filter row filter tooltip': 'Filtro',
  'datagrid grouping grouped by': 'Agrupado por:',
  'datagrid grouping placeholder':
    'Arraste colunas para cá para agrupar o resultado',
  'datagrid header actions': 'Ações', // force not render title for actions column
  'datagrid pagination label displayed rows': '{from}-{to} de {count}',
  'datagrid pagination label rows select': 'registros',
  'datagrid pagination label rows per page': 'Registros por página:',
  'datagrid pagination first aria label': 'Primeira página',
  'datagrid pagination first tooltip': 'Primeira página',
  'datagrid pagination previous aria label': 'Página anterior',
  'datagrid pagination previous tooltip': 'Página anterior',
  'datagrid pagination next aria label': 'Próxima página',
  'datagrid pagination next tooltip': 'Próxima página',
  'datagrid pagination last aria label': 'Última página',
  'datagrid pagination last tooltip': 'Última página',
  'datagrid toolbar add remove columns': 'Selecione as colunas visíveis',
  'datagrid toolbar n rows selected': '{0} registro(s) selecionado(s)',
  'datagrid toolbar show columns title': 'Colunas visíveis',
  'datagrid toolbar show columns aria label': 'Colunas visíveis',
  'datagrid toolbar export title': 'Exportar',
  'datagrid toolbar export aria label': 'Exportar',
  'datagrid toolbar export name': 'Exportar como CSV',
  'datagrid toolbar search tooltip': 'Pesquisar',
  'datagrid toolbar search placeholder': 'Pesquisar...',
  'datagrid fetch loadh error': 'Não foi possível carregar os dados',
  'datagrid show deleted items': 'Exibir itens excluídos',

  'hello world': 'Olá mundo!',
  'dashboard': 'Dashboard',
  'overview': 'Visão geral',
  'name': 'Nome',
  'reference name': 'Nome referência',
  'email': 'E-mail',
  'password': 'Senha',
  'new password': 'Nova senha',
  'current password': 'Senha atual',
  'hide password': 'Esconder senha',
  'show password': 'Mostrar senha',
  'change password': 'Alterar senha',
  'recover password': 'Recuperar senha',
  'new password register': 'Cadastro de nova senha',
  'register new password': 'Cadastrar nova senha',
  'repeat new password': 'Repita a nova senha',
  'login': 'Entrar',
  'logout': 'Sair',
  'database': 'Banco de dados',
  'language': 'Idioma',
  'services': 'Serviços',
  'unit of measurement label ha': 'Hectare',
  'unit of measurement label acre': 'Acre',
  'unit of measurement label alsp': 'Alqueire (SP)',
  'unit of measurement label almg': 'Alqueire (MG)',
  'hectare': '{howMany, plural, one {Hectare} other {Hectares}}',
  'horse power unit': 'cv',
  'recommendation per ha': 'Recomendação (por hectare)',
  'recommendation per acre': 'Recomendação (por acre)',
  'recommendation per alsp': 'Recomendação (por alqueire paulista)',
  'recommendation per almg': 'Recomendação (por alqueire mineiro)',
  'unit': '{howMany, plural, one {Unidade} other {Unidades}}',
  'unit of measurement': '{howMany, plural, one {Unidade} other {Unidades}} de medida',
  '{this} must contain at least {size} characters': '{this} deve conter no mínimo {size} caracteres',
  'user': '{howMany, plural, one {Usuário} other {Usuários}}',
  'functionality': '{howMany, plural, one {Funcionalidade} other {Funcionalidades}}',
  'general': '{howMany, plural, one {Geral} other {Gerais}}',
  'plan': '{howMany, plural, one {Plano} other {Planos}}',
  'invalid cep': 'CEP inválido',
  'empty select options': 'Nenhuma opção encontrada',
  'date of birth': 'Data de Nascimento',
  'start date': 'Data de Início',
  'end date': 'Data de Fim',
  'invalid date': 'Data inválida',
  'invalid number': 'Número inválido',
  'concluded': '{howMany, plural, one {Concluído} other {Concluídos}}',
  'signup': 'Cadastrar',
  'full name': 'Nome Completo',
  'cellphone': 'Celular',
  'phone': 'Telefone',
  'next': 'Próximo',
  'go back': 'Voltar',
  'number': 'Número',
  'total': 'Total',
  'photo': '{howMany, plural, one {Foto} other {Fotos}}',
  'country': '{howMany, plural, one {País} other {Países}}',
  'state': '{howMany, plural, one {Estado} other {Estados}}',
  'city': '{howMany, plural, one {Cidade} other {Cidades}}',
  'code': 'Código',
  'invalid code': 'Código invalido',
  'confirm password': 'Confirmar Senha',
  'passwords do not match': 'As senhas não correspondem',
  'emails do not match': 'Os e-mails não correspondem',
  'fields do not match': 'Os campos não correspondem',
  'welcome to galo monitor': 'Bem-vindo(a)\nao Galo Monitor!',
  'to enter, insert your data': 'Para entrar, insira seus dados:',
  'all right': 'Tudo certo!',
  'success': 'Sucesso!',
  'code send by email': 'Código enviado por e-mail',
  'check your mail app': 'Cheque a caixa de entrada do seu aplicativo de e-mails',
  'close': 'Fechar',
  'full screen': 'Tela inteira',
  'exit full screen': 'Sair da tela inteira',
  'ok': 'Ok',
  'validating your data...': 'Validando seus dados...',
  'yes': 'Sim',
  'no': 'Não',
  'user doesn\'t registered': 'Você ainda não possui cadastro',
  'I forgot my password': 'Esqueceu sua senha?',
  'no problem': 'Sem problemas...',
  'cancel': 'Cancelar',
  'edit': 'Editar',
  'save': 'Salvar',
  'to filter': 'Filtrar',
  'to access': 'Acessar',
  'change': 'Trocar',
  'your {this} was registered': '{gender, select, male {Seu} female {Sua}} {this} foi {gender, select, male {cadastrado} female {cadastrada}}',
  'the value is not valid': 'O valor não é válido',
  'location access required': 'Garantir acesso à minha localização',
  'this app needs to access your location': 'Precisamos acessar a sua localização',
  'location': 'Localização',
  'inform your location': 'Informe a localização correta da sua propriedade (sede)',
  'location can be changed by dragging marker or clicking on map': 'A localização da sua propriedade pode ser alterada arrastando o marcador, ou apenas clicando no mapa',
  'remove': 'Remover',
  'archive': 'Arquivar',
  'archived': '{gender, select, male {Arquivado} female {Arquivada}}',
  'recover': 'Recuperar',
  'recovered': '{gender, select, male {Recuperado} female {Recuperada}}',
  'project status': `
    {status, select,
      waiting {Aguardando}
      finished {Concluído}
      started {Em andamento}
    }
  `,
  'name of the project': 'Nome do projeto',
  '{this} unknown': '{this} não {gender, select, male {informado} female {informada}}',
  '{this} must not exceed {size}': '{this} não pode ser maior que {size}',
  'expand': 'Expandir',
  'retract': 'Retrair',
  '{this} must be greater than 0': '{this} deve ser maior que 0',
  'all': '{gender, select, male {Todos} female {Todas}}',
  'clear': 'Limpar',
  'no data found': 'Não foram encontrados resultados',
  'canceled': '{gender, select, male {Cancelado} female {Cancelada}}',
  'previous': 'Anterior',
  'select month in': 'Selecione o mês de',
  'select year': 'Selecione o ano',
  'access not authorized': 'Acesso não autorizado',
  'login error message': 'Seu e-mail ou senha não correspondem com a sua conta de acesso. Verifique seu e-mail e senha e repita a operação.',
  'expired token error title': 'Token inválido',
  'expired token error message': 'Token inválido ou expirado. Utilize o recurso de recuperação de senha para atualizá-lo.',
  'request location error': 'Erro ao tentar acessar sua localização',
  'access': 'Acesso',
  'remember me': 'Lembrar-me',
  'go back to login screen': 'Voltar para a tela de Login',
  'repeat {this}': 'Repetir {this}',
  'reset {this}': 'Resetar {this}',
  'request sent': 'Solicitação enviada',
  'forgot success message': 'Você receberá um e-mail em sua caixa de entrada com instruções para cadastrar uma nova senha de acesso.',
  'password registered with success': 'Senha cadastrada com sucesso',
  'password changed success message': 'Clique no botão abaixo para fazer o login novamente.',
  'access again': 'Acessar novamente',
  'module': '{howMany, plural, one {Módulo} other {Módulos}}',
  'role': '{howMany, plural, one {Papel} other {Papéis}}',
  'role position': '{howMany, plural, one {Cargo} other {Cargos}}',
  'position': 'Cargo',
  'profile': '{howMany, plural, one {Perfil} other {Perfis}}',
  'application': '{howMany, plural, one {Aplicação} other {Aplicações}}',
  'observation': '{howMany, plural, one {Observação} other {Observações}}',
  'observation abbreviation': 'Obs',
  'personal information': '{howMany, plural, one {Informação Pessoal} other {Informações Pessoais}}',
  'registration information': 'Informações cadastrais',
  'farm info key': `
    {key, select,
      name {Nome da conta}
      nameResponsible {Responsável (cliente)}
      segment {Segmento de Clientes}
      phoneResponsible {Telefone Principal}
      emailResponsible {E-mail}
      plan {Plano}
      other {Chave inválida!}
    }
  `,
  'profile details': 'Detalhes do Perfil',
  'fabrication year': 'Ano de fabricação',
  'potency': 'Potência',
  'motorized equipment': 'Equipamento Motorizado',
  'activity': '{howMany, plural, one {Atividade} other {Atividades}}',
  'register of plot': 'Registro de Talhão',
  'name of plot': 'Nome do Talhão',
  'plot classification': 'Classificação do Talhão',
  'plot': '{howMany, plural, one {Talhão} other {Talhões}}',
  'harvest': '{howMany, plural, one {Safra} other {Safras}}',
  'company': '{howMany, plural, one {Companhia} other {Companhias}}',
  'company client': '{howMany, plural, one {Empresa} other {Empresas}}',
  'account': '{howMany, plural, one {Conta} other {Contas}}',
  'brand': '{howMany, plural, one {Marca} other {Marcas}}',
  'model': '{howMany, plural, one {Modelo} other {Modelos}}',
  'machine': '{howMany, plural, one {Máquina} other {Máquinas}}',
  'raw material': '{howMany, plural, one {Insumo} other {Insumos}}',
  'fertilizer': '{howMany, plural, one {Fertilizante} other {Fertilizantes}}',
  'fertilizer type': 'Tipo de Fertilizante',
  'product type': 'Tipo de Produto',
  'stock': '{howMany, plural, one {Estoque} other {Estoques}}',
  'raw materials stock': '{howMany, plural, one {Estoque de Insumos} other {Estoques de Insumos}}',
  'approximate value': 'Valor aproximado',
  '{this} account': '{howMany, plural, one {Conta} other {Contas}} {this}',
  'manage account': 'Gerenciar conta',
  'list {this}': 'Listar {this}',
  'notification': '{howMany, plural, one {Notificação} other {Notificações}}',
  'type to search {this}': 'Digite para procurar {gender, select, male {{howMany, plural, one {o} other {os}}} female {{howMany, plural, one {a} other {as}}}} {this}',
  'job': '{howMany, plural, one {Tarefa} other {Tarefas}}',
  'farm': '{howMany, plural, one {Fazenda} other {Fazendas}}',
  'property': '{howMany, plural, one {Propriedade} other {Propriedades}}',
  'project': '{howMany, plural, one {Projeto} other {Projetos}}',
  'system': 'Sistema',
  'root': 'Root',
  'route': 'Rota',
  'context': 'Contexto',
  'register': 'Cadastrar',
  'update': 'Atualizar',
  'updated at': 'Atualizada em',
  'import': 'Importar',
  'delete': 'excluir',
  'activate': 'ativar',
  'activated': '{gender, select, male {{howMany, plural, one {Ativado} other {Ativados}}} female {{howMany, plural, one {Ativada} other {Ativadas}}}}',
  'inactivate': 'inativar',
  'inactivated': '{gender, select, male {{howMany, plural, one {Inativado} other {Inativados}}} female {{howMany, plural, one {Inativada} other {Inativadas}}}}',
  'are you sure you want to {action} the "{name}" {this}?': 'Você tem certeza que deseja {action} {gender, select, male {{howMany, plural, one {o} other {os}}} female {{howMany, plural, one {a} other {as}}}} {this} "{name}"?',
  'are you sure you want to delete the "{name}" {this}?': 'Você tem certeza que deseja excluir {gender, select, male {{howMany, plural, one {o} other {os}}} female {{howMany, plural, one {a} other {as}}}} {this} "{name}"?',
  'are you sure you want to reset user "{name}" password?': 'Você tem certeza que deseja resetar a senha do usuário {name}?',
  'are you sure you want to change your password?': 'Você tem certeza que deseja alterar a sua senha?',
  'after processing the registration you will be redirected to login page': 'Após processado o cadastro, você será redirecionado para a página de login e será necessário acessar com a sua nova senha.',
  'user {name} password reset succesfully': 'Senha do usuário {name} foi resetada com sucesso!',
  'a new e-mail will be sent to user': 'Um novo e-mail será enviado para que o usuário registre uma nova senha.',
  'register of {this}': 'Cadastro de {this}',
  '{this} {action} successfully!': '{this} {action} com sucesso!',
  'removed': '{gender, select, male {{howMany, plural, one {Removido} other {Removidos}}} female {{howMany, plural, one {Removida} other {Removidas}}}}',
  'updated': '{gender, select, male {{howMany, plural, one {Atualizado} other {Atualizados}}} female {{howMany, plural, one {Atualizada} other {Atualizadas}}}}',
  'created': '{gender, select, male {{howMany, plural, one {Criado} other {Criados}}} female {{howMany, plural, one {Criada} other {Criadas}}}}',
  '{this} modules': 'Módulos {this}',
  'module permissions': 'Permissões do módulo',
  'company modules': 'Módulos da companhia',
  'plan modules': 'Módulos do plano',
  'loading company data': 'Carregando dados da companhia...',
  'permission': '{howMany, plural, one {Permissão} other {Permissões}}',
  'attach': '{gender, select, male {{howMany, plural, one {Vinculado} other {Vinculados}}} female {{howMany, plural, one {Vinculada} other {Vinculadas}}}}',
  'detach': '{gender, select, male {{howMany, plural, one {Desvinculado} other {Desvinculados}}} female {{howMany, plural, one {Desvinculada} other {Desvinculadas}}}}',
  'active': '{gender, select, male {{howMany, plural, one {Ativo} other {Ativos}}} female {{howMany, plural, one {Ativa} other {Ativas}}}}',
  'you need detach all permissions to delete a module': 'Você precisa desvincular todas as permissões para remover um módulo',
  'you need detach all farms to delete a user': 'Você precisa desvincular todas as fazendas para remover um usuário',
  'you need detach all farms accounts to delete this plan': 'Você precisa desvincular todas as contas farm para remover este plano',
  'you need detach all users to delete this role': 'Você precisa desvincular todos os usuários para remover este papel',
  'could not {action} the {this}': 'Não foi possível {action} {gender, select, male {{howMany, plural, one {o} other {os}}} female {{howMany, plural, one {a} other {as}}}} {this}',
  'you need detach all modules to delete a application': 'Você precisa desvincular essa permissão de todos os módulos para removê-la',
  'there are harvests associated with that culture': 'Existem safras associadas a ela no sistema.',
  'farm settings': 'Configurações da fazenda',
  'company settings': 'Configurações da companhia',
  'configure {this}': 'Configurar {this}',
  'managing {this} permissions': 'Gerenciamento de permissões do {this}',
  'managing {this} modules': 'Gerenciamento de módulos de {this}',
  'view': 'Visualizar',
  'loading': 'Carregando...',
  'responsible (focal point)': 'Responsável (ponto focal)',
  'responsible': 'Responsável',
  'client': 'Cliente',
  'inform the collaborators': 'Informe os colaboradores',
  'segment': '{howMany, plural, one {Segmento} other {Segmentos}}',
  'collaborator': '{howMany, plural, one {Colaborador} other {Colaboradores}}',
  'done': '{howMany, plural, one {Realizado} other {Realizados}}',
  'late': '{howMany, plural, one {Atrasado} other {Atrasados}}',
  'planned': '{howMany, plural, one {Planejado} other {Planejados}}',
  'realized': '{howMany, plural, one {Realizado} other {Realizados}}',
  'exist farms or modules attached to this company': 'Existem fazendas/módulos vinculados à companhia',
  'settings': 'Configurações',
  'status': 'Status',
  'color': 'Cor',
  'type': '{howMany, plural, one {Tipo} other {Tipos}}',
  'file': '{howMany, plural, one {Arquivo} other {Arquivos}}',
  'action': '{howMany, plural, one {Ação} other {Ações}}',
  'to create': 'Criar',
  'to manage': 'Gerenciar',
  'create {this}': 'Criar {this}',
  'import {this}': 'Importar {this}',
  '{this} enabled': '{this} {gender, select, male {{howMany, plural, one {Habilitado} other {Habilitados}}} female {{howMany, plural, one {Habilitada} other {Habilitadas}}}}',
  'name of {this}': '{gender, select, male {{howMany, plural, one {Nome do} other {Nomes dos}}} female {{howMany, plural, one {Nome da} other {Nomes das}}}} {this}',
  'name of account': 'Nome da conta',
  'name of property': 'Nome da propriedade',
  'name of stock': 'Nome do estoque',
  'select the {this}': '{gender, select, male {{howMany, plural, one {Selecione o} other {Selecione os}}} female {{howMany, plural, one {Selecione a} other {Selecione as}}}} {this}',
  'main phone': 'Telefone principal',
  'confirm email': 'Confirmar e-mail',
  'all farms': 'Todas as fazendas',
  'selected farms': 'Fazendas selecionadas',
  'no farms': 'Nenhuma fazenda',
  'all properties': 'Todas as propriedades',
  'all harvests': 'Todas as safras',
  'selected properties': 'Propriedades selecionadas',
  'breeding': '{howMany, plural, one {Criação} other {Criações}}',
  'cultivar': '{howMany, plural, one {Cultivar} other {Cultivares}}',
  'breeder': '{howMany, plural, one {Obtentora} other {Obtentoras}}',
  'culture': '{howMany, plural, one {Cultura} other {Culturas}}',
  'cultivation method': 'Método de cultivo',
  'cultivation method label conventional': 'Convencional',
  'cultivation method label organic': 'Orgânico',
  'cultivation method label hydroponic': 'Hidropônico',
  'mineral': 'Mineral',
  'organic': 'Orgânico',
  'chemical': 'Químico',
  'acaricide': 'Acaricida',
  'bactericidal': 'Bactericida',
  'fungicide': 'Fungicida',
  'herbicide': 'Herbicida',
  'insecticide': 'Inseticida',
  'others': 'Outros',
  'cultivated area': 'Área cultivada',
  'main crops': 'Principais cultivos',
  'my access': '{howMany, plural, one {Meu acesso} other {Meus acessos}}',
  'back to company': 'Voltar para Company',
  'back to management': 'Voltar para gerenciamento',
  'exit farm': 'Sair da fazenda',
  'exit {this}': 'Sair {gender, select, male {do} female {da}} {this}',
  'no options': 'Nenhuma opção encontrada',
  'timezone': 'Fuso horário',
  'available': 'Disponível',
  'area': '{howMany, plural, one {Área} other {Áreas}}',
  'total area': 'Área total',
  'total quantity': 'Quantidade total',
  'gross production': 'Produção Bruta',
  'copyright message': 'Todos os direitos reservados',
  'no access': 'Sem acesso',
  'preference': '{howMany, plural, one {Preferência} other {Preferências}}',
  'show on map': 'Exibir no mapa',
  'period': '{howMany, plural, one {Período} other {Períodos}}',
  'farm accounts access': 'Acessos a Contas Farm',
  'first access message': 'Este é o seu primeiro acesso',
  'register first property message': 'Você precisa cadastrar sua primeira propriedade',
  'select desired property': 'Selecione a propriedade desejada',
  'select the property': 'Selecione a propriedade',
  'try again contact support': 'Tente novamente mais tarde. Se o problema persistir, entre em contato com o nosso suporte.',
  'your farm location is here': 'Localização da sua fazenda',
  'lock map': 'Travar mapa',
  'map classification': 'Classificação do mapa',
  'map': '{howMany, plural, one {Mapa} other {Mapas}}',
  'property overview map': 'Mapa geral da propriedade',
  'polygon': '{howMany, plural, one {Polígono} other {Polígonos}}',
  'to configure your location you must allow navigator': 'Para configurar sua localização, é necessário autorizar o navegador a acessar sua localização',
  'from {start} to {finish}': '{start} a {finish}',
  'unexpected error occurred': 'Ocorreu um erro inesperado',
  'your file is not well formatted': 'Seu arquivo não está formatado de acordo com o nosso processador de arquivos. Tente novamente com outro arquivo e caso o problema persistir, entre em contato com os desenvolvedores.',
  'press enter to include': 'Pressione enter para incluir',
  'add new entry': 'Adicionar nova entrada',
  'add another': 'Adicionar outro',
  'environment being developed': 'Ambiente em desenvolvimento',
  'soon features will be available': 'Em breve, funcionalidades estarão disponíveis',
  'your account was deactivated': 'Sua conta foi desativada',
  'contact system admin': 'Entre em contato com o administrador do sistema',
  'error': 'Erro',
  'sowing': '{howMany, plural, one {Plantio} other {Plantios}}',
  'seeding': '{howMany, plural, one {Semeadura} other {Semeaduras}}',
  'soil preparation': '{howMany, plural, one {Preparo} other {Preparos}} do solo',
  'fertilization': '{howMany, plural, one {Fertilização} other {Fertilizações}}',
  'pesticide': '{howMany, plural, one {Defensivo} other {Defensivos}}',
  'trade name': 'Nome comercial',
  'manufacturer': '{howMany, plural, one {Fabricante} other {Fabricantes}}',
  'pesticide type': 'Tipo de defensivo',
  'origin': 'Origem',
  'formulation': 'Formulação',
  'active ingredient': 'Ingrediente ativo',
  'formulation Powder': 'Pó ({type, select, soluble {solúvel} other {pronto uso}})',
  'formulation Granules': 'Granulado ({type, select, soluble {solúvel} other {pronto uso}})',
  'formulation Tablet': 'Tablete ({type, select, soluble {solúvel} other {pronto uso}})',
  'formulation Liquid': 'Líquido ({type, select, soluble {solúvel} other {pronto uso}})',
  'about the operation': 'Sobre a operação',
  'machines and implements': 'Máquinas e Implementos',
  'select raw material source stock': 'Selecione o estoque de origem do insumo',
  'inform the {this}': 'Informe {howMany, plural, one {o} other {os}} {this}',
  'plantations listing label': 'Semeadura',
  'plantations activity type': 'Semeadura',
  'soil-preparation activity type': 'Preparo do solo',
  'soil-preparation listing label': 'Preparo de solo',
  'fertilizers activity type': 'Fertilização',
  'fertilizers listing label': 'Fertilização',
  'insecticides activity type': 'Aplicação de Defensivos',
  'insecticides listing label': 'Aplicação de Defensivos',
  'harvests activity type': 'Colheita',
  'harvests listing label': 'Colheita',
  'type of {this}': 'Tipo de {this}',
  'liquid': 'Líquido',
  'solid': 'Sólido',
  'dilute in syrup': 'Diluir em calda',
  'syrup volume': 'Volume de calda (por {unit, select, ha {hectare} acre {acre} alsp {alqueire paulista} almg {alqueire mineiro}})',
  'total syrup': 'Quantidade total de calda (área total)',
  'action needed': 'Ação necessária',
  'you are registering an action out of harvest planned period': 'Você está registrando uma atividade para um período fora do planejado para a safra. Deseja registrar mesmo assim?',
  'inventory': 'Inventário',
  'crop': 'Cultivo',
  'country name by locale code': `{
    localeCode, select,
      ptBr {Brasil}
      deDe {Alemanha}
      esEs {Paraguai}
      enUs {Estados Unidos}
  }`,
  'map preferences options': `{
    option, select,
      property-map {Mapa da Propriedade}
      permanent-preservation-area {Área de Preservação Permanente (APP)}
      legal-reserve {Reserva Legal (ALR)}
      dam-lake {Barragem / Lago}
  }`,
  // CONNECTORS
  'and': 'e',
  'in': '{gender, select, male {{howMany, plural, one {no} other {nos}}} female {{howMany, plural, one {na} other {nas}}}}',
  // API Messages
  'invalid coordinates length': 'Número de coordenadas inválido',
  'old password is invalid': 'Sua senha atual está errada',
  'you cannot delete this culture, it is being used': 'Você não pode deletar essa cultura, pois existem safras associadas a ela no sistema',
  'maker has models': 'Marca possui modelos associados a ela',
  'this plan cannot be edited': 'Este plano não pode ser editado',
  'access denied': 'Acesso negado. Entre em contato com o administrador do sistema.',
  'access denied, company is not active': 'Acesso negado! Companhia está inativa!',
  'access denied, farm is not active': `{
    screen, select,
      login {Acesso negado! Fazenda está inativa!}
      inside {
        {
          message, select,
            first {Sua conta foi desativada}
            second {Entre em contato com o administrador do sistema}
        }
      }
  }`,
  'access denied, property is not active':`{
    screen, select,
      login {Acesso negado! Propriedade está inativa!}
      inside {
        {
          message, select,
            first {Você não possui propriedades vinculadas ao seu usuário}
            second {Entre em contato com o administrador do sistema}
        }
      }
  }`,
  'Invalid user credentials': `{
    type, select,
      title {Credenciais inválidas}
      message {Seu e-mail ou senha não correspondem com a sua conta de acesso.}
  }`,
  'farm is not inactive': 'A fazenda está ativa',
  'farm is not found': 'Fazenda não encontrada',
  'you cannot edit the role of Super Admin Farm': 'Você não pode editar o papel Super Admin Farm',
  'validation error message': `
    É obrigatório o campo
    {
      field, select,
        modules_farms {Módulos Farm}
        modules_companies {Módulos Company}
        name_responsible {Nome do Responsável}
        properties_ids {Propriedades selecionadas}
        year_fabrication {Ano de fabricação}
        plots {Talhões}
        color {Cor}
    }. Regra: {rule, select,
      minLength {Quantidade mínima}
      unique {Registro único}
      required {Obrigatório}
    }
  `,
  'minLength validation failed': 'É necessário o preenchimento do campo',
  'unique classification for this map in this property': 'Já existe um mapa na categoria "Mapa Geral da Fazenda". Remova o cadastro anterior ou edite o registro existente.',
  'Arado/subsolador/grade': 'Arado/Subsolador/Grade',
  'Colhedora': 'Colhedora',
  'Plantadeira': 'Plantadeira',
  'Pulverizador': 'Pulverizador',
  'Trator': 'Trator',
  'activity not found': 'Atividade não encontrada',
  'plot classification types': `{
    type, select,
      PA {Produção Agrícola}
      PP {Produção Pecuária}
      PF {Produção Florestal}
      APP {Preservação Permanente (APP)}
      ALR {Reserva Legal (ALR)}
      BL {Barragem / Lago}
      other {Tipo não encontrado}
  }`
}
